import { render } from "./NavigationPhoneMenuCircle.vue?vue&type=template&id=72a54152"
import script from "./NavigationPhoneMenuCircle.vue?vue&type=script&lang=js"
export * from "./NavigationPhoneMenuCircle.vue?vue&type=script&lang=js"

import "./NavigationPhoneMenuCircle.vue?vue&type=style&index=0&id=72a54152&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__